import cardHover from './hover';

const baseCardShared = {
  cursor: 'pointer'
};

const base = {
  interactive: {
    ...baseCardShared,
    ...cardHover.baseHover,
    boxShadow: 'cardList',
    '&:focus, &:focus-within': {
      outline: '3px auto',
      outlineOffset: '8px'
    }
  },
  raised: {
    ...baseCardShared,
    boxShadow: 'cardList'
  },
  template: {
    backgroundColor: 'coolGrey.5',
    padding: 's16'
  }
};

const card = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export type CardVariantsType = 'interactive' | 'raised' | 'template';
export const cardVariants = Object.keys(base) as CardVariantsType[];

export default card;
